<template>
    <div class="ld-container clbrtn-hist-container" style="height: 90vh; width: 100%">
        <div class="row" style="height: 100%">
            <div class="list-area col-md-6">
                <div>
                    <header-box :title="`${$t('유지보수 이력 관리')}`" />
                </div>
                <div style="height: calc(100% - 80px)">
                    <!-- 검색 영역 -->
                    <!-- <div class="search-area">
                        <ClbrtnHistSearch @search:data="onSearch" />
                    </div> -->
                    <!-- 테이블 영역 -->

                    <table-list
                        ref="table-list"
                        :title="'유지보수 목록'"
                        :columns="detailColumns"
                        :rows="detailItems"
                        :keyField="'clbrtnIdx'"
                        :useFilter="true"
                        :fixedHeader="true"
                        :isPageNation="true"
                        :controls="controls"
                        :useMaxHeight="true"
                        :mode="'edit'"
                        :groupField="'facilityName'"
                        @button-click="handleListButtonClick"
                        @row-click="handleDetailRowClick"
                    />
                </div>
            </div>
            <div class="detail-area col-md-6">
                <ClbrtnHistDetail
                    ref="ClbrtnHistDetail"
                    :title="'유지보수 이력'"
                    :selectedRow="selectedRow"
                    @data-updated="handleDetailUpdated"
                    @closed="handleDetailClosed"
                    :clbrnTypeCodeList="clbrnTypeCodeList"
                    :facilityList="calibrationList"
                    :allDetails="detailItems"
                    @refresh="loadAllDetails"
                />
            </div>
        </div>
    </div>
</template>

<script>
import HeaderBox from "@views/component/headerBox/management/Header.vue";
import TableList from "@views/component/v2.1/ListDetailView/TableList.vue";
// import ClbrtnHistSearch from "./ClbrtnHistSearch.vue";
import ClbrtnHistDetail from "./ClbrtnHistDetail.vue";
import backEndApi from "@src/api/backEndApi";
import * as popupMessages from "@src/consts/popupMessageConsts";
import { mapState } from "vuex";

export default {
    components: {
        HeaderBox,
        TableList,
        // ClbrtnHistSearch,
        ClbrtnHistDetail,
    },
    props: {},
    data() {
        return {
            facilityIdx: null,
            calibrationList: [],
            detailItems: [],
            controls: [
                { event: "delete", label: "삭제", class: "btn-danger" },
                { event: "refresh", label: "갱신", class: "bg-white text-black" },
                { event: "regist", label: "추가", class: "btn-primary" },
            ],
            transCodes: [
                {
                    field: "meterTypeCode",
                    codes: this.meterTypeCode,
                },
                {
                    field: "clbrPeriodCode",
                    codes: this.clbrPeriodCode,
                },
                {
                    field: "enabled",
                    codes: this.enabled,
                },
            ],

            detailColumns: [
                // { field: "clbrtnIdx", label: this.$t("식별번호"), tdClass: "text-center " },
                { field: "processDate", label: this.$t("처리일자") },
                {
                    label: this.$t("계측기"),
                    field: "facilityName",
                    type: "text",
                },
                { field: "clbrnTypeCodeName", label: this.$t("유형") },

                { field: "clbrnOrg", label: this.$t("업체") },
                { field: "clbrnWorker", label: this.$t("담당자") },
                { field: "lastClbrnDate", label: this.$t("최종 검교정 일자") },
                { field: "nextClbrnDate", label: this.$t("다음 검교정 일자") },
                { field: "remainDays", label: this.$t("검교정 남은 일수"), tdClass: "text-center" },
                {
                    field: "clbrnDescrb",
                    label: this.$t("상세 내역"),
                    tdClass: "text-left",
                },
            ],
            popupMessages,
            selectedRow: null,
        };
    },
    computed: {
        ...mapState({
            clbrnTypeCodeList: (state) => state.commonCodes.clbrnTypeCode,
            meterTypeCode: (state) => state.commonCodes.meterTypeCode,
            clbrPeriodCode: (state) => state.commonCodes.clbrPeriodCode,
            enabled: (state) => state.commonCodes.enabled,
        }),
    },
    created() {},
    async mounted() {
        await this.loadAllDetails();
    },
    methods: {
        async handleListButtonClick(event, options) {
            switch (event) {
                case "regist":
                    await this.registNew();
                    break;

                case "delete":
                    await this.deleteChecked();
                    break;

                case "refresh":
                    await this.loadAllDetails(event);
                    break;

                default:
                    console.warn("Unhandled Component Event. event:", event, "options:", options);
                    break;
            }
        },

        async handleItemToggle(key, field, status) {
            await this.changeStatus(key, field, status);
        },

        async handleItemClick(row, idx, toggle, check) {
            if (toggle || check) return;

            const confirm = await this.$refs["ClbrtnHistDetail"].notifyCancelEdit();
            if (!confirm) return;

            // 강제로 보기 모드로 전환
            if (this.$refs["ClbrtnHistDetail"]) this.$refs["ClbrtnHistDetail"].isEditMode = false;

            this.facilityIdx = row.facilityIdx;
            this.selectedRow = row;
            await this.getDetailList(row.facilityIdx);
        },

        async getDataList(event) {
            try {
                let result = await backEndApi.clbrtnHist.getClbrnListByFacility();
                if (result.status == 200) {
                    this.calibrationList = result.data;
                    if (event) await this.alertNoti(popupMessages.COMMON_REFRESH_POPUP_MESSAGE);
                } else {
                    this.alertWarning(`${result.data.message}`);
                }
                return result;
            } catch (e) {
                console.error(e);
            }
        },

        async loadAllDetails(event) {
            try {
                const facilityRes = await backEndApi.clbrtnHist.getClbrnListByFacility();
                if (facilityRes.status !== 200) {
                    this.alertWarning(`${facilityRes.data.message}`);
                    return facilityRes;
                }
                this.calibrationList = facilityRes.data || [];

                const requests = this.calibrationList.map((f) =>
                    backEndApi.clbrtnHist.getClbrnHistListByFacility(f.facilityIdx)
                );
                const results = await Promise.allSettled(requests);
                const merged = [];
                results.forEach((r, i) => {
                    if (r.status === "fulfilled" && r.value && r.value.status === 200) {
                        const rows = Array.isArray(r.value.data) ? r.value.data : [r.value.data].filter(Boolean);
                        const facility = this.calibrationList[i];
                        rows.forEach((row) => {
                            merged.push({
                                ...row,
                                ...facility,
                            });
                        });
                    }
                });
                this.detailItems = merged;
                if (event) await this.alertNoti(popupMessages.COMMON_REFRESH_POPUP_MESSAGE);
                return { status: 200, data: merged };
            } catch (e) {
                console.error(e);
            }
        },

        async getDetailList(facilityIdx) {
            try {
                let result = await backEndApi.clbrtnHist.getClbrnHistListByFacility(facilityIdx);
                if (result.status == 200) {
                    const list = Array.isArray(result.data) ? result.data : [result.data].filter(Boolean);
                    this.detailItems = list;
                }
            } catch (e) {
                console.error(e);
            }
        },

        async deleteChecked() {
            const that = this;

            try {
                const confirm = await this.alertConfirmWarning(popupMessages.COMMON_DELETE_CONFIRM_POPUP_MESSAGE);
                if (!confirm.value) return;

                const checked = this.$refs["table-list"].getCheckedRows();
                if (!that.isEmpty(checked)) {
                    checked.forEach(async (item) => {
                        let result = await backEndApi.clbrtnHist.deleteClbrn(item.clbrtnIdx);
                        if (result.status != 200) {
                            this.alertWarning(`${result.data.message}`);
                            return;
                        }
                    });
                    await this.alertNoti(popupMessages.COMMON_DELETE_POPUP_MESSAGE);
                    await this.loadAllDetails();
                    await this.$refs["ClbrtnHistDetail"].clearData();
                } else {
                    this.alertNoti(popupMessages.COMMON_DELETE_NOTI_POPUP_MESSAGE);
                }
            } catch (e) {
                console.error(e);
            }
        },

        async changeStatus(key, field, status) {
            const data = {};
            data["facilityIdx"] = key;
            data[field] = status;

            try {
                let result = await backEndApi.clbrtnHist.setEnabled(data);
                if (result.status == 200) {
                    await this.alertNoti(popupMessages.COMMON_STATUS_CHANGE_SUCCESS_POPUP_MESSAGE);
                    await this.getDataList();
                } else {
                    this.alertWarning(`${result.data.message}`);
                }
            } catch (e) {
                console.error(e);
            }
        },

        async registNew() {
            this.$refs["ClbrtnHistDetail"].newData();
        },

        handleDetailRowClick(row) {
            const payload = row && row.clbrtnIdx ? row : row && row.row ? row.row : row;
            // 편집/신규 모드일 경우 닫기 확인 후 이동
            const proceed = this.$refs["ClbrtnHistDetail"]?.notifyCancelEdit
                ? this.$refs["ClbrtnHistDetail"].notifyCancelEdit()
                : Promise.resolve(true);
            Promise.resolve(proceed).then((ok) => {
                if (!ok) return;
                // 강제로 보기 모드로 전환
                if (this.$refs["ClbrtnHistDetail"]) this.$refs["ClbrtnHistDetail"].isEditMode = false;
                if (payload && payload.facilityIdx) {
                    this.selectedRow = {
                        ...payload,
                    };
                }
                this.$refs["ClbrtnHistDetail"].setSelectedDetail(payload);
            });
        },

        // Event Handling
        async handleDetailUpdated() {
            await this.loadAllDetails();
        },

        handleDetailClosed() {
            this.facilityIdx = null;
        },

        onSearch(data) {
            this.calibrationList = data;
        },
    },
};
</script>

<style scoped>
.ld-container {
    height: 90vh;
    width: 100%;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    padding: 10px 30px 10px 20px;
}

.ld-container .list-area {
    height: 100%;
    overflow: hidden;
    padding: 10px;
}

.ld-container .detail-area {
    height: 100%;
    margin-right: 00px;
    padding: 0px 10px 0px 10px;
    border-top: 1px solid #f4f4f4;
    border-right: 2px solid #e7e7e7;
    border-bottom: 2px solid #e7e7e7;
    border-left: 1px solid #f4f4f4;
    background-color: #f9f9f9;
    border-radius: 10px;
}

.search-area {
    margin-bottom: 10px;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 5px;
}
</style>
